module.exports = __webpack_public_path__ + "img/bespoke70_30.ab5302f5.jpg";